









































import { Component, Prop } from 'vue-property-decorator'

import { PropertyFieldType } from '../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon } from '../../../../../../../../../BotProperties/utils'
import { UseFields } from '../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../Pi/types'
import { ProxyDelayPropertyType } from '../../../logic/Proxy/ProxyDelayTypes'
import DelayLimit from '../components/DelayLimit.vue'

@Component({
  components: {
    DelayLimit,
  }
})
export default class DelayPropertyType extends UseFields {
  @Prop() delay!: ProxyDelayPropertyType

  get properties(): Array<SelectOptionData> {
    return this.delay.getProperties()
      .filter((p) => [ PropertyFieldType.Date, PropertyFieldType.Number, PropertyFieldType.DateTime ].includes(p.type))
      .map((p) => {
        return {
          label: p.name ?? p.type,
          value: p.id,
          icon: {
            name: getNewPropertyIcon(p.path ?? p.type),
            iconPack: 'material-icons',
          }
        }
      })
  }

  get context(): this {
    return this
  }

  get limit(): boolean {
    return !!this.delay.limit
  }

  setProperty(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setProperty(val)
    return arg
  }

  setOffset(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setOffset(val)
    return arg
  }

  setLimit(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.switchLimit(val)
    return arg
  }
}
